import React, {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {LoadingComponent} from 'recupero-comunes'
import { Button, Card, Container } from 'react-bootstrap'
import { Auth } from 'recupero-comunes'
import BuscarCasos from './buscar-casos'
import { configuracionFormAction, obtenerCompanias, obtenerCriteriosFechaAction, obtenerEstadosCasoAction, obtenerRangoFechas, obtenerTareasAction, obtenerTareasUsuarioAction, obtenerSituacionPendiente } from '../../store/actions/recupero-cias-action'
import BandejaCasos from './bandeja-casos'


const RecuperoEntreCIAS = () => {
    const [loading, setLoading]=useState(false)
    const { rutUsuario, rutOrganizacion, roles } = Auth.currentUser();
    const dispatch = useDispatch()
    const data_encargado_recupero = useSelector((state) => state.recupero_cias)
    const {cfg_form} = data_encargado_recupero
    const [tipoGestion, setTipoGestion]=useState(null)//Recupero entre cias

    useEffect(() => {
      //console.log("index.roles: ", roles);
      let tg = "235001";
      roles.forEach(value => {
        if (value.rol === "70RESDECIAS") {
          tg = "235005";          
        }
     })
     setTipoGestion(tg);
    }, [])

    useEffect(() => {
        setLoading(true)
        let query = Buffer.from(
          JSON.stringify({ idform: 31, rutcia: rutOrganizacion })
        ).toString('base64')
        dispatch(configuracionFormAction(query))
        .then(()=>{
              let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, parametro: 1 })
                ).toString('base64')
                dispatch(obtenerRangoFechas(query))
        })
         .then(()=>{
          dispatch(obtenerCompanias())
         })
         .then(()=>{
            let query = Buffer.from(
              JSON.stringify({
                rutcia: rutOrganizacion,
                rutusr: rutUsuario,
                flujo: 2,
                flujo1: 5,
                todos: document.getElementById('todos')
                  ? document.getElementById('todos').checked
                  : false
              })
            ).toString('base64')
            dispatch(obtenerTareasAction(query))
         })
         .then(()=>{
            //console.log("obtenerEstadosCasoAction.tipoGestion: ", tipoGestion);
            if (tipoGestion) {
              let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, concepto: 213, tipoGestion:tipoGestion})
              ).toString('base64')
              dispatch(obtenerEstadosCasoAction(query))
            }
         })
         .then(()=>{
            let query = Buffer.from(
              JSON.stringify({ rutcia: rutOrganizacion, concepto: 29 })
            ).toString('base64')
            dispatch(obtenerCriteriosFechaAction(query))
         })
         .then(()=>{
            let query = Buffer.from(
              JSON.stringify({ rutcia: rutOrganizacion, rutusr: rutUsuario, flujo: 2, flujo1: 5 })
            ).toString('base64')
            dispatch(obtenerTareasUsuarioAction(query))
         })       
         .then(()=>{
          let query = Buffer.from(
            JSON.stringify({ rutcia: rutOrganizacion, concepto: 272 })
          ).toString('base64')
          dispatch(obtenerSituacionPendiente(query))
        })
         .then(()=>setLoading(false))
        
    }, [dispatch, tipoGestion])
    
   
    
    
    return (
        <div> 
             <LoadingComponent show={loading}/>
             <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >{
                                         cfg_form &&  `${cfg_form['bandejarecuperocias-title']}
                                        `}</Card.Header>
                <Card.Body>
                 
                        <BuscarCasos  tipoGestion={tipoGestion}/>
                        <BandejaCasos  />
                  
             </Card.Body>
            </Card>
            </Container> 
          
        </div>
    )
}

export default RecuperoEntreCIAS
